import React from 'react';

function ModalConfirmacao({ aberto, titulo, mensagem, onConfirmar, onCancelar }) {
  if (!aberto) return null;

  return (
    <div className="modal-overlay" onClick={onCancelar}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <h3 style={{ marginBottom: 12 }}>{titulo}</h3>
        <p style={{ fontSize: 14, color: '#555', lineHeight: 1.6 }}>{mensagem}</p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 24 }}>
          <button className="btn-secondary" onClick={onCancelar}>Cancelar</button>
          <button className="btn-danger" onClick={onConfirmar}>Confirmar exclusão</button>
        </div>
      </div>
    </div>
  );
}

export default ModalConfirmacao;
